module.exports = __webpack_public_path__ + "fransa banyo dolabı.jpg?fc9aa4955936c9595f713ce62a734151";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/fransa banyo dolabı.jpg
// module id = 350
// module chunks = 0